import { getFilteredPolicies, IPolicyDoc, PolicyAction, PolicyResource } from "@vmosolutions/oc-interfaces";

//!! This function can also be accessed using redux following the path outlined below.
// useSelector((state: IRootState) => state.authentication.hasFieldPermissions);
// Example Use: hasFieldPermissions(PolicyResource.Flight, "flightNumber")

/**
 * a function to return a functin that can take in a field name and tell you if the user has permissions
 * @param policies- a user's policies
 * @param resource- the resouce that you are requesting the polcies for
 */
export const getResourceFieldPermissions = (policies: IPolicyDoc[], resource: PolicyResource): any => {
  const [allowedPolicies, deniedPolicies] = getFilteredPolicies(policies, resource);

  //a function to return that checks permissions for each field in a form
  const hasFieldPermisson = (fieldName: string): boolean => {
    for (const pol of deniedPolicies) {
      if (pol.action.includes(PolicyAction.Update) || pol.action.includes("*")) {
        for (const field of pol.fields) {
          if (field === "*" || new RegExp(field).test(fieldName)) {
            return false;
          }
        }
      }
    }

    for (const pol of allowedPolicies) {
      if (pol.action.includes(PolicyAction.Update) || pol.action.includes("*")) {
        for (const field of pol.fields) {
          if (field === "*" || new RegExp(field).test(fieldName)) {
            return true;
          }
        }
      }
    }
    return false;
  };
  return hasFieldPermisson;
};
